export const fourCardsInRowCardWidthPercentage = 25;
export const fourCardsInRowCardGapPx = 32;
export const threeCardsInRowCardWidthPercentage = 33;
export const threeCardsInRowCardGapPx = 31;
export const narrowColumnWidth = 1390;
export const cardTitleCharacterLimit = 70;
export const cardDescriptionCharacterLimit = 190;
